import { getLocale } from 'JIX/utils.js';

/**
 * Given a date-only string or number in JIX format ("20111010") returns a Date
 * object representing the start of that day in local time.
 */
export function fromJixDate(str) {
    const match = String(str).match(/^(\d{4})(\d{2})(\d{2})$/);
    if (match) {
        // 'T00:00' postfix is needed to force Date to be interpreted as local
        // time and not as UTC.
        return new Date(`${match[1]}-${match[2]}-${match[3]}T00:00`);
    } else {
        throw new Error(`Argument is invalid jixdate: '${str}'`);
    }
}

/**
 * Given a date-only string in ISO8601 format ("2011-10-10") returns a Date
 * object representing the start of that day in local time.
 */
export function fromIsoDate(str) {
    // 'T00:00' postfix is needed to force Date to be interpreted as local
    // time and not as UTC.
    return new Date(`${str}T00:00`);
}

export function toIsoDate(datetime) {
    let date = ("0" + datetime.getDate()).slice(-2);
    let month = ("0" + (datetime.getMonth() + 1)).slice(-2);
    return `${datetime.getFullYear()}-${month}-${date}`;
}

export function toHourMinuteString(datetime) {
    return datetime.toTimeString().substr(0, 5);
}

const formatters = {};

export function getDateFormatter(locale = getLocale()) {
    if (!formatters[locale]) {
        formatters[locale] = (date, options = {}) => {
            const formatOptions = {
                month: options.month || 'long',
                day: 'numeric',
            };

            const addTime = 'addTime' in options ? options.addTime : false;
            if (addTime === true) {
                formatOptions.hour = 'numeric';
                formatOptions.minute = 'numeric';
            } else if (addTime === false) {
                // Default
            } else {
                throw new Error("Invalid addTime value");
            }

            const addYear = 'addYear' in options ? options.addYear : 'auto';
            if (addYear === 'auto') {
                if (date.getYear() !== new Date().getYear()) {
                    formatOptions.year = 'numeric';
                }
            } else if (addYear === true) {
                formatOptions.year = 'numeric';
            } else if (addYear === false) {
                // Default
            } else {
                throw new Error("Invalid addYear value");
            }

            const formatter = new Intl.DateTimeFormat(locale, formatOptions);
            return formatter.format(date);
        };
    }
    return formatters[locale];
}

export function isLeapYear(year) {
    return (year % 4 === 0) && (year % 100 !== 0) || (year % 400 === 0);
}

const _daysInMonth = [undefined, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export function daysInMonth(year, month) {
    const res = _daysInMonth[month];
    return month === 2 && isLeapYear(year) ? res + 1 : res;
}

export function formatAsJixDate(dateObject) {
    let date = ("0" + dateObject.getDate()).slice(-2);
    let month = ("0" + (dateObject.getMonth() + 1)).slice(-2);
    return dateObject.getFullYear() + month + date;
}
